import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d6b7752"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "consent-check" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "consent-check-switch" }
const _hoisted_4 = { class: "mb-8 mt-2 d-flex flex-row align-items-center" }
const _hoisted_5 = { class: "label label-false" }
const _hoisted_6 = { class: "form-check form-switch form-check-custom form-check-solid px-2" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = { class: "label label-yes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "consent-check-content",
      innerHTML: $props.content
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("No")), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            checked: $props.checked,
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleSwitch && $setup.handleSwitch(...args)))
          }, null, 40, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Yes")), 1)
      ])
    ])
  ]))
}